import TextBoldIcon from '@atlaskit/icon/core/text-bold';
import * as React from 'react';

export function SvgBold() {
  return <TextBoldIcon label="" testId="ads-refreshed-icon" />;
}
